export const STATUS_IDLE = 'idle';

export const STATUS_FETCHING = 'fetching';

export const STATUS_ERROR = 'error';

export const STATUS_READY = 'ready';
